import { DateTime } from "luxon";
import { StampDirection } from "../../../shared/timeclock/models";
import { AuthenticatedPerson, ExistingStamp } from "../../../shared/timeclock/models/IAuthenticatedPerson";

export function isPrimaryDirectionIn(lastStamp?: ExistingStamp): boolean {
    const neverStamped = !lastStamp;
    const didNotStampToday = lastStamp && !lastStamp.dateTime.hasSame(DateTime.now(), "day");
    const lastStampWasOut = lastStamp && StampDirection[lastStamp.direction] === StampDirection.Out;

    return neverStamped || didNotStampToday || lastStampWasOut;
}

export function isPrimaryDirectionOut(lastStamp?: ExistingStamp): boolean {
    return !isPrimaryDirectionIn(lastStamp);
}

export function getPrimaryStampDirection(lastStamp?: ExistingStamp): StampDirection.In | StampDirection.Out {
    return isPrimaryDirectionIn(lastStamp) ? StampDirection.In : StampDirection.Out;
}

export function getSecondaryStampDirection(lastStamp?: ExistingStamp): StampDirection.In | StampDirection.Out {
    return isPrimaryDirectionIn(lastStamp) ? StampDirection.Out : StampDirection.In;
}

export function isChangeDirectionAvailable(person: AuthenticatedPerson): boolean {
    return person.stampOperations.filter(so => StampDirection[so.direction] === StampDirection.Change).length > 0;
}
